import { ConfigService } from './config.service';

declare global {
  interface Window {
    PubMatic: { config: object };
  }
}

export const ConfigServiceFactory = () => {
  const config = new ConfigService();
  const namespace = window.PubMatic;

  // Read environment variables from browser window
  if (!namespace || !namespace.config) {
    throw new Error('App config is not available');
  }

  // Load config from browser window
  // In the current implementation, properties from config.js overwrite defaults from the ConfigService.
  // If needed, a deep merge can be performed here to merge properties instead of overwriting them.

  return Object.assign(config, namespace.config);
};

export const ConfigServiceProvider = {
  provide: ConfigService,
  useFactory: ConfigServiceFactory,
  deps: [],
};
